/**
 * useRegistryStatus — the ledger status strip behind the registry glass
 * (metrics substrate S5).
 *
 * Reads GET /api/registry — the LIVE ledger state only (per-atom-type counts +
 * newest event_date, revisions + newest revision day, latest state, and the
 * latest run marker; four bounded D1 SELECTs, zero Airtable). The registry CANON is bundled, so the glass renders atoms
 * with no fetch; this poll refreshes only the counts as the daily extractor
 * lands new atoms — so it is slow (5 min), enough to see a run land without
 * hammering the worker.
 */

import { RegistryLedgerStatusResponseSchema } from "@command-center/shared";
import { createPollingQuery } from "./create-polling-query";

export const useRegistryStatus = createPollingQuery({
  queryKey: ["registry-status"] as const,
  path: "/api/registry",
  schema: RegistryLedgerStatusResponseSchema,
  refetchIntervalMs: 5 * 60_000,
});
